import { SubsidiaryModeAlert } from "PFApp/components/subsidiary_mode_alert";
import React, { useCallback, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import { BOOKING_PAGE_HEADER_HEIGHT } from "../../../booking_page";
import css from "./info_overlay.module.scss";

type InfoOverlayProps = {
  headerRef: React.MutableRefObject<HTMLDivElement>;
  onClose: () => void;
  message: string;
} & Pick<React.ComponentProps<typeof SubsidiaryModeAlert>, "actions">;

const ALERT_TOP = 46;
const TOP_NAVBAR_HEIGHT = 30;
const TOOLBAR_TOP_DISTANCE = 6;

const checkIfShouldBeSticky = () =>
  window.scrollY >= BOOKING_PAGE_HEADER_HEIGHT + TOP_NAVBAR_HEIGHT + TOOLBAR_TOP_DISTANCE - ALERT_TOP;

export const InfoOverlay = ({ headerRef, message, onClose, actions }: InfoOverlayProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const scrollListener = useCallback(() => {
    if (!ref.current) {
      return;
    }
    const isSticky = checkIfShouldBeSticky();
    if (isSticky) {
      const distanceFromViewportTopToStickyPlace =
        BOOKING_PAGE_HEADER_HEIGHT + TOP_NAVBAR_HEIGHT + TOOLBAR_TOP_DISTANCE - window.scrollY;
      ref.current.style.top = `${Math.max(TOOLBAR_TOP_DISTANCE, distanceFromViewportTopToStickyPlace)}px`;
    } else {
      ref.current.style.top = `${ALERT_TOP}px`;
    }
  }, []);

  useEffect(() => {
    scrollListener();
    document.addEventListener("scroll", scrollListener);
    return () => {
      document.removeEventListener("scroll", scrollListener);
    };
  }, [scrollListener]);

  if (!headerRef.current) {
    return null;
  }

  return (
    <>
      {createPortal(
        <div className={css.container}>
          <div className={css.content} ref={ref}>
            <SubsidiaryModeAlert title={message} onClose={onClose} actions={actions} />
          </div>
        </div>,
        headerRef.current
      )}
    </>
  );
};
